import "./App.css";
import Map from "./components/Map";

function App() {
  return (
    <div className="App">
      <main>
        <div className="sponsor-logos">
          <img
            src="/assets/uber-logo.png"
            alt="Uber Logo"
            className="sponsor-logo"
          ></img>
          <img
            src="/assets/rl-logo-white.png"
            alt="Uber Logo"
            className="sponsor-logo"
          ></img>
        </div>
        <img src="/assets/Dites-parade.png" alt="Logo" className="logo"></img>

        <Map />

        <div className="footer">
          <p>A Project By Team Richmond Live</p>
        </div>
      </main>
    </div>
  );
}

export default App;
